import AnnotationEditor from "components/AnnotationEditor";
import { Annotation } from "types/annotation.types";
import Header from "components/common/Header";
import Sidebar from "components/common/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { checkProjectStatus } from "services/project";

const AnnotationTool = () => {
  const navigate = useNavigate();
  const { id: projectId, vijilizeId } = useParams();
  const editorRef = useRef<any>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [annotationsChanged, setAnnotationsChanged] = useState(false);

  useEffect(() => {
    fetchProjectStatus()
  }, [])

  const fetchProjectStatus = async () => {
    try {
      const { data } = await checkProjectStatus(projectId)
      console.log({ data })
    } catch (error: any) {
      if (error?.statusCode == 404) {
        navigate('/project')
      }
      console.log({ getProjectStatusError: error })
    }
  }

  const handleUpdate = async () => {
    if (editorRef.current && editorRef.current.handleUpdateAnnotatedImage) {
      setIsUpdating(true);
      await editorRef.current.handleUpdateAnnotatedImage();
      setIsUpdating(false);
    }
  };

  const handleAnnotationsChange = (annotations: any[]) => {
    // Mark that annotations have changed to show the update button
    setAnnotationsChanged(true);
    console.log("Annotations updated:", annotations);
  };

  return (
    <div className="dashboard-wrapper flex">
      <Sidebar />
      <div className="w-[calc(100%_-_72px)] ml-auto">
        <Header
          title="Annotation Tool"
          count={0}
          isChildEle={true}
          type="project"
        />
        <div className="pt-4 px-4 min-h-[calc(100vh_-_69px)] overflow-y-auto scrollbar-adjust bg-[#f9fafb]">
          <div className="bg-white rounded-lg shadow-customShadow5 p-8 w-full overflow-hidden">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-xl font-interSemiBold text-[#1A202C]">
                Annotation
              </h1>
              <div className="flex items-center gap-2">
                {annotationsChanged && (
                  <button
                    onClick={handleUpdate}
                    disabled={isUpdating}
                    className={`px-4 py-2 flex items-center ${isUpdating
                      ? "bg-gray-400"
                      : "bg-green-600 hover:bg-green-700"
                      } text-white rounded transition`}
                  >
                    {isUpdating ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Updating...
                      </>
                    ) : (
                      "Update Annotated Image"
                    )}
                  </button>
                )}
                <button
                  onClick={() => navigate(-1)}
                  className="flex items-center text-sm text-[#1751D0] font-interMedium hover:underline"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Back
                </button>
              </div>
            </div>

            <div className="w-full min-h-[calc(100vh_-_200px)] overflow-auto">
              <AnnotationEditor
                ref={editorRef}
                onAnnotationsChange={handleAnnotationsChange}
                className="custom-editor w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnotationTool;
